function applyContrastColor(wrapperElement) {
  if (!wrapperElement) return;

  const rgbString = wrapperElement.dataset.bgColor;
  if (!rgbString) return;

  const nums = rgbString.match(/\d+/g);
  if (!nums || nums.length < 3) return;
  const [r, g, b] = nums.map(Number);

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  const isDark = brightness < 150;

  const lightHex = '#FDFDFD';
  const darkHex  = '#2B2B2B';
  const fgHex   = isDark ? lightHex : darkHex;
  const fgRgb   = isDark ? '255,255,255' : '0,0,0';

  wrapperElement.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;

  wrapperElement.style.color = fgHex;
  wrapperElement.style.setProperty('--fg', fgHex);
  wrapperElement.style.setProperty('--fg-rgb', fgRgb);

  wrapperElement.querySelectorAll('.rgb-chart__bar')
    .forEach(bar => { bar.style.backgroundColor = fgHex; });
  wrapperElement.querySelectorAll('.custom-split__pane--left, .content-divider')
    .forEach(el => { el.style.borderColor = fgHex; });
}